<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user.js";

    export let points = null;
    export let max = 0;

    let userId = null;
    let progress = 0;

    const load = () => {
        const onSuccess = result => {
            points = result.points;
            max = result.max;
        }

        const onFailure = err => {
        };

        R.handle(R.member.points, [], onSuccess, onFailure, LOADER.PAGE);
    }

    // if ($user.token && points == null) {
    //     load();
    // }

    $: {
        if (!userId && $user.id) {
            userId = $user.id;
            load();
        }
        if (points && max > 0) {
            progress = ~~(points * 100) / max;
        }
    }
</script>

{#if $user.token}
    <div class="panel-simple panel-points box-shadow rounded mb-4">
        <div class="panel-pad pb-4">
            <div class="fw-semibold">points</div>
            <div class="points">
                {#if points}
                    { points }
                {:else}
                    &nbsp;
                {/if}
            </div>
        </div>
        <div class="points-scale">
            <div class="matrix">
                <div class="matrix-bar">
                    <div class="points-progress" style="width: { progress }%;"></div>
                    <div class="points-circle" style="left: { progress }%;"></div>
                </div>
            </div>
            <div class="scale scale-1">
                <div class="name">Blanco</div>
            </div>
            <div class="scale scale-2">
                <div class="name">Gold</div>
            </div>
            <div class="scale scale-3">
                <div class="name">Platinum</div>
            </div>
        </div>
    </div>
{/if}

<style>
    .panel-points {
        overflow: hidden;
    }

    .panel-points .points {
        font-size: 32px;
        font-weight: 600;
    }

    .points-scale {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .points-scale .scale {
        width: 33.3333333333%;
        height: 85px;
        border-right: 1px dotted #c3c3c3;
        z-index: 1;
    }

    .points-scale .scale:last-child {
        border-right: none;
    }

    .points-scale .scale .name {
        text-align: center;
        color: #68748b;
    }

    .points-scale .matrix {
        background: rgb(178, 230, 252);
        background: linear-gradient(180deg, rgba(178, 230, 252, 1) 0%, rgba(230, 247, 254, 1) 100%);
        position: absolute;
        width: 100%;
        height: 50px;
        bottom: 0;
    }

    .points-scale .matrix-bar {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        /*background: #c5ecfd;*/
        background: #38bdf8;
        height: 5px;
        z-index: 5;
    }

    .points-scale .matrix-bar .points-progress {
        position: absolute;

        background: #fb7185;
        /*width: 30%;*/
        top: 0;
        left: 0;
        bottom: 0;
        transition: all .5s ease-in-out;
    }

    .points-scale .matrix-bar .points-circle {
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 15px;
        height: 15px;
        background: #fb7185;
        border: 2px solid #fff;
        border-radius: 50%;
        transition: all .5s ease-in-out;
    }
</style>